import Vuex from 'vuex'
import Vue from 'vue'
import MobileDetect from 'mobile-detect'
import _ from 'lodash'
import { call } from '../Service'
Vue.use(Vuex)

const FETCHDATA_VW_SUCCESS = 'FETCHDATA_VW_SUCCESS'
const FETCHDATA_VW_REQUEST = 'FETCHDATA_VW_REQUEST'
const FETCHDATA_VW_ERROR = 'FETCHDATA_VW_ERROR'
// const OUTPUT_4K_LIMIT = {
//   '1': [0, 0, 1920, 1080],
//   '2': [1921, 0, 3840, 1080],
//   '3': [0, 1081, 1920, 2160],
//   '4': [1921, 1081, 3840, 2160]
// }

const FROM_RESIZE = 'fromResize'
const FROM_GESTURE = 'fromGesture'
const FROM_DRAG = 'fromDrag'
const FROM_INPUT = 'fromInput'
const DOUBLE_INPUT_VW = 'VW-1404ZH-G'

// function limitX1Range (id, x) {
//   if (x < OUTPUT_4K_LIMIT[id][0]) return OUTPUT_4K_LIMIT[id][0]
//   return x
// }

// function limitX2Range (id, x1) {
//   if (x1 > OUTPUT_4K_LIMIT[id][2]) return OUTPUT_4K_LIMIT[id][2]
//   return x1
// }

// function limitY1Range (id, y) {
//   if (y < OUTPUT_4K_LIMIT[id][1]) return OUTPUT_4K_LIMIT[id][1]
//   return y
// }

// function limitY2Range (id, y2) {
//   if (y2 > OUTPUT_4K_LIMIT[id][3]) return OUTPUT_4K_LIMIT[id][3]
//   return y2
// }
// checkDragRange is to avoid overflow of width of 1920 or height of 1080
function checkDragRange (split, index) {
  let port = _.cloneDeep(split[index])
  const width = port[2] - port[0]
  const height = port[3] - port[1]
  if (width > 1920) {
    port[2] = port[0] + 1920
  }

  if (height > 1080) {
    port[3] = port[1] + 1080
  }
  // keep the shape of the rect, just move the position
  split[index] = port
  return split
}

function ratioComputer (resolution) {
  let newRatio = []
  switch (resolution) { // input just has port 1
    case '800x600':
    case '800x600@60':
    default:
      newRatio = [4, 3, 200] // [width, height, baseWidth]
      break
    case '3840x2160@60Hz':
    case '4096x2160@60Hz':
    case '4096x2160@30Hz':
    case '3840x2160@30Hz':
      newRatio = [16, 9, 240]
      break
    case '1080 to 4K2K@60':
    case '1920x1080@30Hz':
    case '1920x1080@60Hz':
      newRatio = [16, 9, 120]
      break
    case '1280x720@60Hz':
      newRatio = [16, 9, 80]
      break
    case '720x480@60Hz':
    case '720x480@30Hz':
      newRatio = [3, 2, 240]
      break
    case '720x576@30Hz':
    case '720x576@50Hz':
      newRatio = [5, 4, 256]
      break
    case '1680x1050@60':
      newRatio = [8, 5, 210]
      break

    case '640x480':
    case '640x480@60':
    case '480p':
      newRatio = [4, 3, 160]
      break
  }
  let md = new MobileDetect(window.navigator.userAgent)
  let ww = window.innerWidth
  if (md.mobile() !== null && window.innerWidth <= 768) {
    if (ww === 320) { // i5
      newRatio.push(Math.round(280 / newRatio[0]))
    } else if (ww === 375 || ww === 360) { // i6 && S5
      newRatio.push(Math.round(320 / newRatio[0]))
    } else if (ww === 414 || ww === 412 || ww === 411) { // i6+ && nexus 6P
      newRatio.push(Math.round(360 / newRatio[0]))
    } else if (ww === 568) { // i5 landscape
      newRatio.push(Math.round(330 / newRatio[0]))
    } else if (ww === 684) {
      newRatio.push(Math.round(400 / newRatio[0]))
    } else if (ww > 568 && ww <= 667) {
      newRatio.push(Math.round(400 / newRatio[0]))
    } else if (ww > 667 && ww <= 736) {
      newRatio.push(Math.round(450 / newRatio[0]))
    } else if (ww === 768) {
      newRatio.push(Math.round(400 / newRatio[0]))
    } else { // set 300 to others
      newRatio.push(Math.round(300 / newRatio[0]))
    }
  } else if (window.innerWidth > 768 && window.innerWidth < 992) {
    newRatio.push(Math.round(450 / newRatio[0])) // ipad UP
  } else if (window.innerWidth >= 992 && window.innerWidth < 1200) {
    newRatio.push(Math.round(550 / newRatio[0])) // md
  } else if (window.innerWidth >= 1200) {
    newRatio.push(Math.round(680 / newRatio[0])) // lg
  }
  // console.log('new ratio is', newRatio)
  return newRatio
}

const state = {
  isFetching: false,
  isInput4k: false,
  isLayoutChanged: false,
  splitArea: {
    split: {}
  },
  inResolution: {},
  outResolutions: {},
  outResolutionOptions: {},
  inRatio: [],
  presetRatios: {},
  windowFocus: '1',
  defaultOutputSplitOpts: {
    '1': '3x1L',   // 3*1 rotate left 90 deg
    '2': '3x1R',   // 3*1 rotate right 90 deg
    '3': '4x1L',   // 4*1 rotate left 90 deg
    '4': '4x1R',   // 4*1 rotate right 90 deg
    '5': '1x1',
    '6': '2x2',
    '7': '1x4',
    '8': '4x1'
  },
  profiles: {},
  error: {},
  isMobile: false,
  model: '',
  isInputSourceFromHDMI: false
}

const mutations = {
  [FETCHDATA_VW_SUCCESS] (state, {    // fetching success, update the state, and let component get them
    inResolution,
    outResolutions,
    outResolutionOptions,
    splitArea,
    outputSplitOptions,
    profiles,
    model
  }) {
    state.isFetching = false
    state.inResolution = inResolution
    state.outResolutions = outResolutions
    state.outResolutionOptions = outResolutionOptions
    state.splitArea.split = splitArea.split
    state.defaultOutputSplitOpts = outputSplitOptions
    state.isInput4k = state.inResolution['1'] === '3840x2160@60Hz' || state.inResolution['1'] === '4096x2160@60Hz'
    state.profiles = profiles
    state.model = model
  },
  [FETCHDATA_VW_REQUEST] (state) {
    state.isFetching = true
  },
  [FETCHDATA_VW_ERROR] (state, error) {
    state.isFetching = false
    state.error = error
  },
  check4KLimit (state, { index, type = FROM_INPUT }) {
    console.log('check4KLimit')
    let oldSplit = _.cloneDeep(state.splitArea.split)
    if (type === FROM_INPUT || type === FROM_RESIZE) {
      // limit the width and height only
      if (parseInt(oldSplit[index][2]) - parseInt(oldSplit[index][0]) > 1920) oldSplit[index][2] = parseInt(oldSplit[index][0]) + 1920
      if (parseInt(oldSplit[index][3]) - parseInt(oldSplit[index][1]) > 1080) oldSplit[index][3] = parseInt(oldSplit[index][1]) + 1080
    } else if (type === FROM_DRAG) {
      oldSplit = checkDragRange(oldSplit, index)
    } else if (type === FROM_GESTURE) {
      // seems to be no this type?
      console.log('sth wrong')
    }
    state.splitArea.split = oldSplit
  },
  UPDATE (state, {type, splitArea, resolution, windowFocus, isLayoutChanged, preset}) {
    // console.warn('got update , type => ', type)
    let md = new MobileDetect(window.navigator.userAgent)
    switch (type) {
      case 'isMobile':
         // && window.innerWidth <= 768
        state.isMobile = md.mobile() !== null
        break
      case 'layoutChanged':
        state.isLayoutChanged = isLayoutChanged
        break
      case 'split':
        // Object.assign seems not to trigger the vuex watch system
        // So we use the dump way

        // It maybe the situations that update 1 output or multi outputs,
        // So update the ports following the keys

        let keys = Object.keys(splitArea.split)
        let newSplit = _.cloneDeep(state.splitArea.split)
        for (let key of keys) {
          newSplit[key] = splitArea.split[key]
        }

        state.splitArea.split = newSplit
        break

      case 'winFocus':
        console.log('focus is', windowFocus)
        state.windowFocus = windowFocus
        break

      case 'inResolution':
      case 'outResolutions':
        Object.assign(state[type], resolution)
        // update the isInput4k here
        if (type === 'inResolution') {
          state.isInput4k = (resolution['1'] === '3840x2160@60Hz' || resolution['1'] === '4096x2160@60Hz')
        }
        break

      case 'preset':
        Object.assign(state.profiles, preset)
        break

      case 'presetRatio':
        for (let pKey in state.profiles) {
          state.presetRatios[pKey] = ratioComputer(state.profiles[pKey].resolution)
        }
        break

      case 'inRatio':
        let newRatio = ratioComputer(state.inResolution['1'])
        state.inRatio = newRatio
        // console.log('inResolution', state.inResolution)
        break

      default:
    }
  },
  updateInputSourcFrom (state, isFromHDMI) {
    state.isInputSourceFromHDMI = isFromHDMI
  }
}

const actions = {
  updateMainScreenSize ({ commit }) {
    commit('UPDATE', {
      type: 'isMobile'
    })
    commit('UPDATE', {
      type: 'inRatio'
    })
  },
  updatePreset ({ commit, state }, preset) {
    commit('UPDATE', {
      type: 'preset',
      preset
    })
    commit('UPDATE', {
      type: 'presetRatio'
    })
  },
  // fetchData need async operation, so put it in actions
  fetchData ({ commit, state, dispatch }, mac) {
    commit(FETCHDATA_VW_REQUEST)
    let params = {
      splitArea: {
        split: {}
      }
    }
    call(mac, 'dxGetAbout').then(({model}) => {
      params.model = model
      dispatch('fetchSource', {mac, model})
      return call(mac, 'dxGetInputResolution')
    }).then(({resolution}) => {
      params.inResolution = resolution
      return call(mac, 'dxGetOutputResolution')
    }).then(({resolution}) => {
      params.outResolutions = resolution
      return call(mac, 'dxGetOutputResolutionOptions')
    }).then(({options}) => {
      params.outResolutionOptions = options
      return call(mac, 'dxGetOutputSplitOptions')
    }).then(({options}) => {
      params.outputSplitOptions = options
      return call(mac, 'dxGetProfiles')
    }).then(({profiles}) => {
      params.profiles = profiles
      return call(mac, 'dxGetSplitArea')
    }).then(({split}) => {
      params.splitArea.split = split
      commit(FETCHDATA_VW_SUCCESS, params)
      commit('UPDATE', {
        type: 'inRatio'
      })
      commit('UPDATE', {
        type: 'isMobile'
      })
      commit('UPDATE', {
        type: 'presetRatio'
      })
    }).catch(e => {
      console.log('error while fetching data', e)
      commit(FETCHDATA_VW_ERROR, e)
    })
  },
  fetchSource ({commit, state}, {mac, model}) {
    if (model === DOUBLE_INPUT_VW || model === 'vw 1x4-virtual') {
      call(mac, 'dxGetInputSource').then(({ isSourceFromHDMI }) => {
        commit('updateInputSourcFrom', isSourceFromHDMI)
      })
    }
  }
}
const getters = {
  getIsFetching: state => state.isFetching,
  getIsInput4k: state => {
    return state.isInput4k
  },
  getOutResolutionOptions: state => state.outResolutionOptions,
  getOutResolutions: state => state.outResolutions,
  getOutputPorts: state => Object.keys(state.splitArea.split),
  getOutputSplitOptions: state => state.defaultOutputSplitOpts,
  getInResolution: state => state.inResolution,
  getSplitArea: state => state.splitArea.split,
  getInRatio: state => state.inRatio,
  getInScreenWidth: state => state.inRatio[0] * state.inRatio[3],
  getInScreenHeight: state => state.inRatio[1] * state.inRatio[3],
  getProfiles: state => state.profiles,
  getWindowFocus: state => state.windowFocus,
  isFocus1: state => state.windowFocus === '1',
  isFocus2: state => state.windowFocus === '2',
  isFocus3: state => state.windowFocus === '3',
  isFocus4: state => state.windowFocus === '4',
  getLayoutChanged: state => state.isLayoutChanged,
  getComputedSplit: state => {
    let newSplit = _.cloneDeep(state.splitArea)
    for (let key of newSplit) {
      for (let i in newSplit[key]) {
        newSplit[key][i] = newSplit[key][i] / state.inRatio[2] * state.inRatio[3]
      }
    }
    return newSplit
  },
  getCanSetRotatedSplit: state => {
    let out1Resolution = state.outResolutionOptions[state.outResolutions['1']]
    let out2Resolution = state.outResolutionOptions[state.outResolutions['2']]
    let out3Resolution = state.outResolutionOptions[state.outResolutions['3']]
    let out4Resolution = state.outResolutionOptions[state.outResolutions['4']]
    let inResolution = state.inResolution['1']
    // console.log('out1', out1Resolution)
    // console.log('out2', out2Resolution)
    // console.log('out3', out3Resolution)
    // console.log('out4', out4Resolution)
    // console.log('in', inResolution)
    return checkResolutionIsIn1920x1080(out1Resolution) && checkResolutionIsIn1920x1080(out2Resolution) && checkResolutionIsIn1920x1080(out3Resolution) && checkResolutionIsIn1920x1080(out4Resolution) && checkResolutionIsIn1920x1080(inResolution)
  },
  getIsMobile: state => state.isMobile,
  getPresetRatios: state => state.presetRatios,
  getDeviceModel: state => state.model,
  getIsSourceFromHDMI: state => state.isInputSourceFromHDMI
}

function checkResolutionIsIn1920x1080 (resolution) {
  return resolution.toLowerCase().includes('1920x1080@')
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/store/videoStore.js